// Cart Summary Component
// Displays cart totals and checkout button

import { NavLink } from 'react-router-dom';
import { useCart } from '@/contexts/CartContext';
import styles from './CartSummary.module.css';

interface CartSummaryProps {
  className?: string;
}

export function CartSummary({ className }: CartSummaryProps) {
  const { itemCount, total, items } = useCart();

  // Format price
  const formatPrice = (price: number) => {
    return `$${Math.round(price).toLocaleString()}`;
  };

  // Calculate subtotal (should match totalAmount for now, no shipping/discount)
  const subtotal = items.reduce((sum, item) => sum + item.subtotal, 0);
  const shippingFee = 0;
  const discount = 0;

  if (itemCount === 0) {
    return (
      <div className={`${styles.cartSummary} ${className || ''}`}>
        <p className={styles.emptyMessage}>您的購物車是空的</p>
        <NavLink to="/products" className={styles.shopButton}>
          繼續購物
        </NavLink>
      </div>
    );
  }

  return (
    <div className={`${styles.cartSummary} ${className || ''}`}>
      <div className={styles.summaryRow}>
        <span className={styles.label}>商品小計</span>
        <span className={styles.value}>{formatPrice(subtotal)}</span>
      </div>

      <div className={styles.summaryRow}>
        <span className={styles.label}>運費</span>
        <span className={styles.value}>{shippingFee === 0 ? '免運' : formatPrice(shippingFee)}</span>
      </div>

      {discount > 0 && (
        <div className={styles.summaryRow}>
          <span className={styles.label}>折扣</span>
          <span className={styles.value}>-{formatPrice(discount)}</span>
        </div>
      )}

      <div className={`${styles.summaryRow} ${styles.totalRow}`}>
        <span className={styles.label}>總計</span>
        <span className={`${styles.value} ${styles.totalValue}`}>{formatPrice(total)}</span>
      </div>

      <NavLink to="/checkout" className={styles.checkoutButton}>
        前往結帳 ({itemCount} 件商品)
      </NavLink>
    </div>
  );
}
